import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProduction = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 8C12 8.1875 11.875 8.375 11.7188 8.4375L8.1875 10.2188L6.4375 13.7188C6.34375 13.9063 6.1875 14 6 14C5.8125 14 5.625 13.9063 5.53125 13.7188L3.78125 10.2188L0.25 8.4375C0.09375 8.375 0 8.1875 0 8C0 7.8125 0.09375 7.625 0.25 7.5625L3.78125 5.78125L5.53125 2.28125C5.71875 1.9375 6.25 1.9375 6.4375 2.28125L8.1875 5.78125L11.7188 7.5625C11.875 7.625 12 7.8125 12 8ZM7.59375 9.40625L10.375 8L7.59375 6.625C7.5 6.5625 7.40625 6.5 7.375 6.375L6 3.625L4.59375 6.375C4.5625 6.5 4.46875 6.5625 4.375 6.625L1.59375 8L4.375 9.40625C4.46875 9.4375 4.5625 9.53125 4.59375 9.625L6 12.375L7.375 9.625C7.40625 9.53125 7.5 9.4375 7.59375 9.40625ZM10.5 3.5C10.2188 3.5 10 3.28125 10 3C10 2.75 10.2188 2.5 10.5 2.5H12.5V0.5C12.5 0.25 12.7188 0 13 0C13.25 0 13.5 0.25 13.5 0.5V2.5H15.5C15.75 2.5 16 2.75 16 3C16 3.28125 15.75 3.5 15.5 3.5H13.5V5.5C13.5 5.78125 13.25 6 13 6C12.7188 6 12.5 5.78125 12.5 5.5V3.5H10.5ZM15.5 12.5C15.75 12.5 16 12.75 16 13C16 13.2813 15.75 13.5 15.5 13.5H13.5V15.5C13.5 15.7813 13.25 16 13 16C12.7188 16 12.5 15.7813 12.5 15.5V13.5H10.5C10.2188 13.5 10 13.2813 10 13C10 12.75 10.2188 12.5 10.5 12.5H12.5V10.5C12.5 10.25 12.7188 10 13 10C13.25 10 13.5 10.25 13.5 10.5V12.5H15.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgProduction);
export { ForwardRef as ReactComponent };
